const filterCategories = (categories, store) => {
  const onlyShowLiveCategories = (item) => {
    if (!store.getters.showCMS) {
      return item.isLive;
    }
    return true;
  };

  const onlyShowNonEmptyCategories = (item) => {
    function hasPopulatedChildCategories(categoryId) {
      const category = store.getters["api/allCategories"]().find(
        (cat) => cat._id === categoryId
      );

      if (!category) {
        return false;
      }

      return (
        category.entries?.length > 0 ||
        category.categories?.some((subcategoryId) =>
          hasPopulatedChildCategories(subcategoryId)
        )
      );
    }

    const shouldHideItem =
      (!item.entries || item.entries.length === 0) &&
      (!item.categories ||
        !item.categories?.some((cat) => hasPopulatedChildCategories(cat)));

    if (!store.getters.showCMS) {
      return !shouldHideItem;
    }

    return true;
  };

  const onlyShowCategoryUrlQueries = (item) => {
    if (!store.getters.showCMS) {
      const categoriesToShow = store.getters.getCategoriesURLQueries;
      if (categoriesToShow) {
        return categoriesToShow.includes(item.categoryName);
      }
    }
    return true;
  };

  // remove NEW FOLDER and Restored Profiles, in case they are published
  const onlyShowCategoriesWithoutDefaultTitle = (item) => {
    if (!store.getters.showCMS) {
      return (
        item.categoryName !== "NEW FOLDER" &&
        item.categoryName !== "Restored Profiles"
      );
    }
    return true;
  };

  return categories
    .filter(onlyShowLiveCategories)
    .filter(onlyShowNonEmptyCategories)
    .filter(onlyShowCategoryUrlQueries)
    .filter(onlyShowCategoriesWithoutDefaultTitle);
};

export { filterCategories };
